<script lang="ts">
	import Badge from '$lib/components/ui/badge/badge.svelte';
	import Container from '$lib/components/ui/container/container.svelte';
	import { Tabs, TabsContent, TabsList, TabsTrigger } from '$lib/components/ui/tabs';
	import { fade } from 'svelte/transition';
	import PricingOptionCard from './_components/pricing-option-card.svelte';
	import { freeTierFeatures, premiumTierFeatures, meekoPlusTierFeatures } from '$lib/utils';
	import { page } from '$app/stores';
</script>

<Container class="mb-12 mt-24 gap-12" id="pricing">
	<div
		class="relative mx-auto flex max-w-2xl flex-col items-center justify-center gap-6 lg:mx-0 lg:max-w-none"
	>
		<enhanced:img
			src="/static/images/star_full.png"
			alt="img"
			class="absolute right-[40px] top-[230px] h-4 w-4"
		/>
		<enhanced:img
			src="/static/images/star_full.png"
			alt="img"
			class="absolute left-[80px] top-[170px] h-4 w-4"
		/>
		<h2 class="text-center text-4xl sm:text-5xl">
			Pro insights available for <span class="text-primary">everyone.</span>
		</h2>
		<p class="max-w-xl px-2 text-center font-light tracking-wider text-lightTertiary">
			Meeko makes professional League of Legends knowledge accessible to everyone with our generous
			pricing tiers
		</p>
	</div>
	<div class="bg-lines-pattern mt-60 max-h-[1000px] max-w-[1000px]" />
	<div class="bg-spotlight-medium mx-auto aspect-square max-w-full" />
	<Tabs value="monthly" class="w-full">
		<TabsList
			class="mx-auto flex h-auto w-80 items-center justify-center rounded-full bg-[#000000]"
		>
			<TabsTrigger class="h-full w-1/2 rounded-full py-3" value="monthly">Monthly</TabsTrigger>
			<TabsTrigger value="yearly" class="w-1/2 gap-3"
				>Yearly <Badge
					class="bg-green-700/20 px-3 py-1 text-sm text-green-600 hover:bg-green-400/20">-15%</Badge
				></TabsTrigger
			>
		</TabsList>
		<TabsContent value="yearly" class="mt-12">
			<div
				class="grid w-full grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3"
				transition:fade={{ duration: 200 }}
			>
				<!-- ANNUAL FREE -->
				<PricingOptionCard
					title="Basic"
					euroPricePerMonth={0}
					description="As a free user you get to ask up to 5 questions per day, just enough to get you through your daily games."
					ctaText="Get started for free"
					features={freeTierFeatures}
				/>
				<!-- ANNUAL PREMIUM -->
				<PricingOptionCard
					title="Early Bird"
					euroPricePerMonth={8.29}
					description="Get instant Desktop App access, ask unlimited questions and much more by becoming an Early Bird."
					ctaText="Become an Early Bird"
					features={premiumTierFeatures}
					isCurrentPlan={$page.data?.user?.isPremium ? true : false}
					interval="YEARLY"
					plan="PREMIUM"
				/>
				<!-- ANNUAL MEEKO+ -->
				<PricingOptionCard
					title="Meeko+"
					euroPricePerMonth={12.49}
					description="Turn Meeko into your personal coach with Meeko+. Includes everything from the lower tiers and our advanced proactive mode."
					ctaText="Coming soon"
					features={meekoPlusTierFeatures}
					superFeature="Meeko+ Proactive"
					interval="YEARLY"
					disabled={true}
				/>
			</div>
		</TabsContent>
		<TabsContent value="monthly" class="mt-12">
			<div
				class="grid w-full grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3"
				transition:fade={{ duration: 200 }}
			>
				<!-- FREE -->
				<PricingOptionCard
					title="Basic"
					euroPricePerMonth={0}
					description="As a free user you get to ask up to 5 questions per day, just enough to get you through your daily games."
					ctaText="Get started for free"
					features={freeTierFeatures}
				/>
				<!-- PREMIUM -->
				<PricingOptionCard
					title="Early Bird"
					euroPricePerMonth={9.99}
					description="Get instant Desktop App access, ask unlimited questions and much more by becoming an Early Bird."
					ctaText="Become an Early Bird"
					features={premiumTierFeatures}
					isCurrentPlan={$page.data?.user?.isPremium ? true : false}
					interval="MONTHLY"
					plan="PREMIUM"
				/>
				<!-- MEEKO+ -->
				<PricingOptionCard
					title="Meeko+"
					euroPricePerMonth={14.99}
					description="Turn Meeko into your personal coach with Meeko+. Includes everything from the lower tiers and our advanced proactive mode."
					ctaText="Coming soon"
					features={meekoPlusTierFeatures}
					superFeature="Meeko+ Proactive"
					disabled={true}
				/>
			</div>
		</TabsContent>
	</Tabs>
</Container>
